import * as React from 'react'
import autobind from "autobind-decorator"
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Layout, Menu, Spin, Icon } from 'antd'
const SubMenu = Menu.SubMenu
const { Header, Content, Footer, Sider } = Layout
import ShellHeader from './shell-header'
import { withSize } from 'react-sizeme'
import EnGB from 'antd/es/locale/en_GB'
import EsEs from 'antd/es/locale/es_ES'
import FrFr from 'antd/es/locale/fr_FR'
import PtBr from 'antd/es/locale/pt_BR'
import PtPT from 'antd/es/locale/pt_PT'
import DeDe from 'antd/es/locale/de_DE'
import ItIt from 'antd/es/locale/it_IT'
import { ConfigProvider } from 'antd'
import FooterView from "./footer"
import i18next from 'i18next'

interface ShellProps extends RouteComponentProps, WithTranslation {
  logo?: any,
  footerLogo?: any,
  prefix?: string,
  ensureCompanySelection?: boolean
  children?: React.ReactNode,
  getSideMenu?: (t: (value: string) => string, screenWidth: number) => React.ReactNode[],
  getTopMainMenu?: (t: (value: string) => string, screenWidth: number) => React.ReactNode[],
  getTopRightMenu?: (t: (value: string) => string, screenWidth: number) => React.ReactNode[],
  onMenuClick?: (key: string) => void,
  footer?: React.ReactNode,
  languages?: string[]
}

interface ShellState {
  collapsed: boolean
  isBusy: boolean
}

export interface IsBusyInterface {
  isBusy: boolean,
  setIsBusy: (isBusy: boolean) => void
}

export interface IsBusyComponentProps {
  busyContext: IsBusyInterface
}

const { Consumer, Provider } = React.createContext<IsBusyInterface | null>(null)
export function withBusyContext<T extends React.ComponentClass<any, any>>(Component: T) {
  return function ComponentBoundWithAppContext(props: any) {
    return (
      <Consumer>
        {busyContext => <Component {...props} busyContext={busyContext} />}
      </Consumer>
    )
  }
}

function getLanguage() {
  switch (i18next.language) {
    case "es": return EsEs
    case "en": return EnGB
    case "fr": return FrFr
    case "pt-BR": return PtBr
    case "pt-PT": return PtBr
    case "de": return DeDe
    case "it": return ItIt
  }
  return EnGB
}
class Shell extends React.Component<ShellProps, ShellState> {
  constructor(props: ShellProps) {
    super(props)
    this.state = {
      collapsed: true,
      isBusy: false,
    }
  }

  @autobind
  private setIsBusy(isBusy: boolean) {
    this.setState({ isBusy: isBusy })
  }

  @autobind
  private toggle() {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  @autobind
  private handleMenuClick(e: any) {
    switch (e.key) {
      case 'logoff':
        //this.identityService.logOff();
        break
      case 'trigger':
        this.toggle()
        break
      default:
        if (this.props.onMenuClick)
          this.props.onMenuClick(e.key)
        break
    };
  }

  public render() {
    const { t } = this.props
    var width = (this.props as any).size.width
    const isBusyContext: IsBusyInterface = {
      isBusy: this.state.isBusy,
      setIsBusy: this.setIsBusy
    }
    var originalMenus = this.props.getSideMenu ? this.props.getSideMenu(t, width) : []
    var menu = [<Menu.Item key="trigger" onClick={this.toggle} className="triggerMenu">
      <Icon
        key='menu-trigger'
        className="trigger"
        type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
        style={{ marginLeft: -3, marginTop: 15, fontSize: this.state.collapsed ? '24px' : '16px' }}
        onClick={this.toggle}
      />
      <span>{!this.state.collapsed && <b>FIniciativas v0.0.1</b>}&nbsp;</span>
    </Menu.Item>, ...originalMenus]

    return <ConfigProvider locale={getLanguage()}>
      <Spin spinning={this.state.isBusy}>
        <Provider value={isBusyContext}>

          <Layout style={{ height: "100vh", overflow: 'hidden' }}>
            {originalMenus.length > 0 && <Sider
              trigger={null}
              collapsedWidth={56}
              collapsible
              collapsed={this.state.collapsed}
              className="mainSlider">
              <div className="logo" />
              <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']} onClick={this.handleMenuClick}>
                {menu}
              </Menu>
            </Sider>}
            <Layout style={{ minHeight: "calc(100vh)", overflow: 'hidden' }}>
              <Header>
                {/*<div className="logo"></div>*/}
                <ShellHeader  prefix={this.props.prefix} logo={this.props.logo} getTopMainMenu={this.props.getTopMainMenu} getTopRightMenu={this.props.getTopRightMenu} ensureCompanySelection={this.props.ensureCompanySelection} languages={this.props.languages} />
              </Header>
              <Content style={{ overflow: 'auto' }}>
                <div style={{ minHeight: "calc(100vh - 111px)" }} >
                  {this.props.children}
                </div>
                {this.props.footer ? this.props.footer :
                  <FooterView footerLogo={this.props.footerLogo} />}
              </Content>
            </Layout>

          </Layout>

        </Provider>
      </Spin>
    </ConfigProvider>
  }
  getTernAndConditionLink(): string | undefined {
    throw new Error('Method not implemented.')
  }
}
export default withTranslation()(withSize()(withRouter(Shell as any)) as any) as any